import React from "react";
import ProcesoCliente from "../../componentsPrestamo/EstadoCliente/ProcesoCliente";

const Cliente = () => {
  return <ProcesoCliente />;
};

export default Cliente;
